import { render, staticRenderFns } from "./DeactivatedUser.vue?vue&type=template&id=60cd0251&scoped=true&"
import script from "./DeactivatedUser.vue?vue&type=script&lang=js&"
export * from "./DeactivatedUser.vue?vue&type=script&lang=js&"
import style0 from "./DeactivatedUser.vue?vue&type=style&index=0&id=60cd0251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd0251",
  null
  
)

export default component.exports